import Skeleton from "@/components/common/Skeleton";
import { useUserStore } from "@/modules/auth/store/user";
import { Avatar } from "@boringer-avatars/react";
import { useTranslation } from "react-i18next";

const Sponsor = () => {
  const { t } = useTranslation();
  const { invitedBy, refcode, isReferralLoading } = useUserStore();

  return (
    <div className="flex w-full flex-col">
      <p className="p-4 pb-2 text-[0.8125rem] leading-[1rem] text-section-header-text tracking-tighter uppercase">
        {t("main-page.your_sponsor_id")}
      </p>
      <div className="w-full flex items-center justify-between gap-4 px-4 py-0.5 bg-plain-background rounded-[0.75rem]">
        <div className="flex items-center gap-4">
          <Avatar
            title={false}
            name={invitedBy || 0}
            size={28}
            variant="beam"
            square={false}
          />
          
          <div className="flex flex-col py-3 gap-0.5">
            {isReferralLoading ? (
              <Skeleton className="w-15 h-5.5" />
            ) : (
              <p className="text-[1.0625rem] leading-[1.375rem] text-text">
                {invitedBy
                  ? invitedBy
                  : !invitedBy && !refcode
                  ? t("main-page.not_connected")
                  : t("main-page.no_sponsor")}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sponsor;
